import { createTheme } from '@mui/material/styles'; // Correct import path for v6+

/**
 * YoCompito brand theme — based on the "Guía básica de estilo y aplicación de marca".
 *
 * Official palette:
 *   Amarillo Energético  #ECFF2D  (primary accent — backgrounds/accents ONLY, never as text on light)
 *   Gris Intenso         #323232  (primary dark — base background)
 *   Gris Intermedio      #5B5B5B
 *   Gris Suave           #848484
 *   Gris Plateado        #D8D9D3
 *   Gris Base            #FDFEF1
 *
 * Contrast rule baked in: the neon yellow is ~0.90 luminance, so it pairs ONLY with
 * Gris Intenso. `primary.contrastText` is locked to #323232 so every `color="primary"`
 * surface (buttons, chips) gets dark text — white-on-yellow can never happen by default.
 */

// Brand tokens — single source of truth.
export const brand = {
    amarillo: '#ECFF2D',   // Amarillo Energético
    intenso: '#323232',    // Gris Intenso
    intermedio: '#5B5B5B', // Gris Intermedio
    suave: '#848484',      // Gris Suave
    plateado: '#D8D9D3',   // Gris Plateado
    base: '#FDFEF1',       // Gris Base
} as const;

export const theme = createTheme({
    palette: {
        mode: 'dark',

        // Amarillo Energético — always with dark (#323232) text on top.
        primary: {
            main: brand.amarillo,
            contrastText: brand.intenso,
        },

        // Gris Plateado as the neutral secondary accent (replaces the off-brand red).
        secondary: {
            main: brand.plateado,
            contrastText: brand.intenso,
        },

        // Gris Intenso is the base; cards sit one step lighter for elevation.
        background: {
            default: brand.intenso, // #323232
            paper: '#3D3D3D',       // elevated charcoal (within the brand charcoal family)
        },
        text: {
            primary: brand.base,         // #FDFEF1 warm white
            secondary: brand.plateado,   // #D8D9D3 (9:1 on charcoal — AAA)
            disabled: brand.suave,       // #848484
        },
        divider: 'rgba(216, 217, 211, 0.16)', // Gris Plateado at low opacity
    },

    typography: {
        fontFamily: '"Helvetica Neue LT Std", "Helvetica Neue", Helvetica, Arial, sans-serif',
        // Keep the existing compact base size used across the app.
        fontSize: 12,
    },
});
